<template>
  <!-- 打开新手人福利弹窗 -->
  <van-popup v-model="showImg" class="transparent-popup">
    <div class="v-pop-img">
      <div class="content" @click="close">
        <van-image class="img" :src="imgUrl" fit="cover" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup as VanPopup, Image as VanImage } from "vant";

export default {
  name: "VPopImg",

  components: {
    VanPopup,
    VanImage,
  },

  props: {},

  data() {
    return {
      // 展示弹窗
      showImg: false,
      imgUrl: "",
    };
  },

  methods: {
    // 显示弹窗
    open(url) {
      this.imgUrl = url;
      this.showImg = true;
    },
    // 关闭弹窗
    close() {
      this.showImg = false;
    },
  },
};
</script>

<style lang="less" scoped>
// 弹窗背景透明
.transparent-popup {
  background-color: transparent !important;
}
//  图片弹窗
.v-pop-img {
  position: relative;
  width: 310px;
  padding-bottom: 35px;
  .btn-close {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -18px;
    width: 36px;
    height: 36px;
  }
  .pop-title {
    padding: 20px 16px 20px;
    text-align: center;
    font-weight: 500;
    font-size: 17px;
    color: #474747;
  }
  .content {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #474747;
    text-align: center;
    .name {
      margin-bottom: 5px;
      font-size: 15px;
      font-weight: 600;
    }
    .img {
      width: 100%;
    }
  }
}
</style>
